import React, {useContext, useEffect, useMemo, useState} from "react";
import Select from "react-select";
import GenericTemplate from "../../templates/GenericTemplate";
import {
  ZEUS_DELIVERY_TYPE_STRING,
  ZEUS_DELIVERY_TYPE_STRING_SHORT,
  apollo_useStyles,
  options_state_edit,
  valueToOption,
  Option,
  ZEUS_DOMAIN_SETTING,
} from "../../atom/Apollo_styles_Beta";
import {
  quasi_reservation_state_number,
  menu_id_number,
  use_status_number,
  getQuasiReservationIconStyle,
} from "../../atom/Apollo_styles";
import {ApolloDateRangePicker} from "../../atom/Apollo_DateRangePicker";
import ApolloPerformance from "../../molecule/Apollo_Performance";
import {SelectMenu} from "../../molecule/Apollo_SelectMenu";
import {ApolloContext} from "../../atom/Apollo_Context";
import {ApolloMessage, CustomizedSnackbars} from "../../atom/Apollo_Mesasge";
import {
  adgroups_path,
  apollo_account_budget_cost_performances,
  apollo_campaign_performances,
  get_zeus_campaign_path,
  patch_zeus_campaign_path,
  get_ms_campaign_path,
  put_ms_campaign_path,
  campaignedit_path,
  apollo_setpoints_path,
  apollo_account_platform_menu_path,
  get_ms_account_path,
} from "../../atom/Apollo_links"
import {
  GroupedOption,
  ColoredOption,
  options_menu_kind,
  options_select_all,
  options_setpoint_columns,
} from "../../atom/Apollo_Options";
import {
  BLANK,
  UNDER_SCORE,
  ALL,
  SELECT_ALL,
  DEMOGRAPHIC_DISPLAY_PERIOD,
  CampaignColumns,
  CsvData,
  MSG,
  RESULT_SETPOINT_ERROR,
  SUMMARY_SETPOINT_COLUMNS,
  TRACKING_POINT,
  ColumnData,
} from "../../common/Apollo_CommonConst_Beta";
import {ApolloRightDrawerContext, RightDrawer} from "../../molecule/Apollo_RightDrawer";
import {ApolloAxios, isSuccessApi} from "../../atom/Apollo_ApiRequest3";
import {APOLLO_SYSTEM_ADMIN, APOLLO_GROUP_OPERATOR, APOLLO_PROFILE_SYSTEM_ADMIN, ApolloUserProfileAuth, IsAuthorization} from "../../atom/Apollo_Authorization";
import {DataTableOptions, STORAGE_KEY} from "../../atom/Apollo_DataTable";
// メッセージ定義
import {
  GetMessage,
  UI_INDIVIDUAL_SUMMARY,
} from "../../atom/Apollo_MesasgeDefinition";
// 認証期間切れの処理
import {ApolloExpired} from "../../atom/Apollo_Expired";
import {ApolloEventRecord, LogData, ItemList} from "../../atom/Apollo_EventRecord";

import Grid from "@material-ui/core/Grid";
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from "@material-ui/core/IconButton";
import Fab from "@material-ui/core/Fab";
import {Link, useHistory} from "react-router-dom";
import EditIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/Add';
import Chip from '@material-ui/core/Chip'
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader"
import Button from "@material-ui/core/Button"
import Box from "@material-ui/core/Box"
import Switch from '@material-ui/core/Switch';
import InputLabel from "@material-ui/core/InputLabel";
import {toNumber} from 'lodash';
import {MUIDataTableColumnDef, MUISortOptions, MUIDataTableColumn} from "mui-datatables";
import moment from 'moment'
import {cloneDeep} from "lodash";

import {
  AccountBudgetCostPerformance,
  PlatformCampaignRawData,
  PlatformCampaignTableData,
  PlatformCampaignTableRow,
  PlatformDemographicRawData,
  PerfomanceSetPoints,
} from "./SummaryModel"
import CampaignEditMs from "../CAMPAIGN/ms/CampaignEditMs";
import {ApolloBreadcrumbs2, BreadcrumbsData} from "../../atom/Apollo_Breadcrumbs2";
import {
  sortStringToNumber,
  sortByUnderscoreParts,
  mergeOptions,
} from "../../common/Apollo_CommonUtil_Beta";
import {LintChartStorageKey} from "./LineChart_Beta";
import {Backdrop, createTheme} from "@material-ui/core";
import {Bars} from "react-loader-spinner";
import CampaignEditZeus from "../CAMPAIGN/zeus/CampaignEditZeus";
import {CampaignZeus} from "../CAMPAIGN/zeus/CampaignModelZeus";
import {Campaign, CampaignUpdate} from "../CAMPAIGN/ms/common/CommonModel";
import {ThemeProvider, makeStyles} from "@material-ui/core/styles";
import {ROW_PER_PAGE_OPTIONS} from "../../common/Apollo_CommonConst";
import {
  APOLLO_PAGE_ID,
  applyApolloSharedColumnSettings,
  createApolloSharedTableOptions,
  getApolloDynamicColumnId,
  getApolloSharedCalendar,
  getApolloSharedFilterList,
  saveApolloSharedCalendar,
} from "../../common/Apollo_LocalStorageSettings";

const ApolloPerformanceMemo = React.memo(ApolloPerformance);

export const PLATFORM_TYPE = {
  ZEUS: 1,
  MS: 2,
}

const valueToLabel = function (value: any, options: Array<{ value: any; label: string }>): string {
  let option = options.find(option => option.value === value)
  if (!option) {
    return "";
  } else {
    return option.label;
  }
};

/**
 * 日付形式に変換して返す
 * @param {moment.Moment} momentInstance
 * @returns {string}
 */
const toUtcIso8601str = (momentInstance: moment.Moment) => {
  return momentInstance
    .clone()
    // .utc()
    .format('YYYY-MM-DD')
}

export const DATE_TIME_SUFFIX = "Z"

const ISummaryPage: React.FC = () => {

  const isAuthorization = IsAuthorization(APOLLO_SYSTEM_ADMIN, APOLLO_PROFILE_SYSTEM_ADMIN);
            
  const MIN_START_DATE = moment("2025-10-01");
  const DEFAULT_END_DATE = moment("2025-10-31");
  const LIMIT_DATE = moment("2025-09-30");

  // 条件判定
  const isBeforeLimit = moment().isSameOrBefore(LIMIT_DATE, "day");

  const defaultStartDate = !isAuthorization && isBeforeLimit
    ? toUtcIso8601str(MIN_START_DATE)
    : toUtcIso8601str(moment().startOf("month"));
  const defaultEndDate = !isAuthorization && isBeforeLimit
    ? toUtcIso8601str(DEFAULT_END_DATE)
    : toUtcIso8601str(moment().endOf("month"));
  const initialCalendar = getApolloSharedCalendar({
    startDate: defaultStartDate,
    endDate: defaultEndDate,
  });

  const [startDate, setStartDate] = useState(initialCalendar.startDate);
  const [endDate, setEndDate] = useState(initialCalendar.endDate);
  const [previousStartDate, setPreviousStartDate] = useState(toUtcIso8601str(moment().startOf('month')))
  const [previousEndDate, setPreviousEndDate] = useState(toUtcIso8601str(moment().endOf('month')))
  const [previousChartRawData, setPreviousChartRawData] = useState<PlatformCampaignRawData>([])
  const [isPreviousPeriodChecked, setIsPreviousPeriodChecked]= useState<boolean>(false)
  const [isPreviousPeriodDisabled, setIsPreviousPeriodDisabled]= useState<boolean>(false)
  const [isChartDataLoaded, setIsChartDataLoaded] = useState(false);
  const [selectedValues, setSelectedValues] = useState<any[]>([...options_select_all]);
  const [filterValues, setFilterValues] = useState<string[]>([ALL]);
  const [demographicRawData, setDemographicRawData] = useState<PlatformDemographicRawData>([])
  const [demographicDisplayPeriod, setDemographicDisplayPeriod] = useState<number>(DEMOGRAPHIC_DISPLAY_PERIOD.LAST_MONTH);
  const [setPoints, setSetPoints] = useState<Option[]>([]);
  const [deletedSetPoints, setDeletedSetPoints] = useState<Option[]>([]);
  const [isSetPointsLoaded, setIsSetPointsLoaded] = useState(false);
  const [isDemographicDataLoaded, setIsDemographicDataLoaded] = useState(false);
  const [referenceDate, setReferenceDate] = useState<string>(toUtcIso8601str(moment().add(-1, 'day')));
  // 前期間データ取得起動カウンタ
  const [fetchPreviousDataStart, setFetchPreviousDataStart] = useState<number>(0);
  // ステータストグル押下フラグ
  const [isPushStatusToggle, setIsPushStatusToggle] = useState<boolean>(false);

  const breadcrumbsData: BreadcrumbsData = {
    categoryId: 23,
    breadId: 1,
    queries: [
      "",
      "?type=ca",
    ],
    menu: null,
    campaign: null,
    adgroup: null,
    advertisement: null,
    asset: null,
  }

  const [sortOrder, setSortOrder] = useState<MUISortOptions>({
    name: "id",
    direction: 'desc',
  })

  const [updateListCnt, setUpdateListCnt]  = useState<number>(0)
  const listReloadFunc = () => {
    setDrawerState({
      type: 'close',
      payload: {
        ...drawerState,
        open: false,
      }
    })
    setUpdateListCnt(updateListCnt + 1)
  };

  const [hasMSRtmCampaign, setHasMSRtmCampaign]  = useState<boolean>(false)
  const [tableData, setTableData] = useState<PlatformCampaignTableData>([])
  const [chartRawData, setChartRawData] = useState<PlatformCampaignRawData>([])
  const [reflectAt, setReflectAt] = useState<string>("")

  // キャンペーン新規作成モーダル用
  const [openDialog, setOpenDialog] = useState<boolean>(false)

  const initEditCampaign: PlatformCampaignTableRow = {
    id: "",
    platformId: 0,
    platformName: "",
    campaignType: "",
    platformCampaignName: "",
    platformAccountId: 0,
    status: 0,
    campaignGoal: "",
    chargeType: "",
    pmpType: "",
    domainSetting: 0,
    budgetLimit: 0,
    startAt: "",
    endAt: "",
    targetCpa: 0,
    adCampaignExcludingDomains: [],
    adCampaignTargetDomains: [],
    colorCode: "",
    cost: 0,
    imp: 0,
    vimp: 0,
    click: 0,
    ctr: 0,
    vctr: 0,
    cpc: 0,
    cpm: 0,
    trackingPointCvTotal: 0,
    trackingPointCvClickThrough: 0,
    trackingPointCvAssist: 0,
    trackingPointCpaTotal: 0,
    trackingPointCpaClickThrough: 0,
    trackingPointCpaAssist: 0,
    trackingPointCvrTotal: 0,
    trackingPointCvrClickThrough: 0,
    trackingPointCvrAssist: 0,
    lastCvTotal: 0,
    lastCvClickThrough: 0,
    lastCvAssist: 0,
    lastCpaTotal: 0,
    lastCpaClickThrough: 0,
    lastCpaAssist: 0,
    lastCvrTotal: 0,
    lastCvrClickThrough: 0,
    lastCvrAssist: 0,
    trackingPointCvClickThroughSetPoints: [],
    trackingPointCvAssistSetPoints: [],
    trackingPointCpaClickThroughSetPoints: [],
    trackingPointCvrClickThroughSetPoints: [],
  }

  // 編集対象キャンペーン
  const [editCampaign, setEditCampaign] = useState<PlatformCampaignTableRow>(initEditCampaign)

  const {state} = useContext(ApolloContext);
  const {data, setmsg} = useContext(ApolloMessage);
  const {drawerState, setDrawerState} = React.useContext(ApolloRightDrawerContext);
  const classes = apollo_useStyles();

  const accountId = state.current.accountId
  const accountGroupId = state.current.accountGroupId

  const [columnFilterForStatus, setColumnFilterForStatus] = useState(
    getApolloSharedFilterList("status", options_state_edit.filter(elem => elem.value !== 3).map(elem => elem.label))
  )
  // リダイレクト(認証期間切れの場合にリダイレクトするため)
  const history = useHistory();
  // 期間変更比較用
  type BeforeStartEndDate = {
    startDate: string,
    endDate: string,
  }
  const currentBeforeDate = React.useRef<BeforeStartEndDate>({
    startDate: "",
    endDate: "",
  });
  const previousBeforeDate = React.useRef<BeforeStartEndDate>({
    startDate: "",
    endDate: "",
  });

  const columns: MUIDataTableColumnDef[] = [
    {
      name: "",
      label: "",
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        customBodyRenderLite: (idx: number) => {
          return (
            <Tooltip title="キャンペーン編集" placement="bottom">
              <IconButton
                size="small"
                color="primary"
                aria-label="edit"
                onClick={() => {
                  setEditCampaign(tableData[idx]);
                  setDrawerState({
                    type: 'open',
                    payload: {
                      ...drawerState,
                      open: true,
                    }
                  });
                }}>
                <EditIcon/>
              </IconButton>
            </Tooltip>
          );
        }
      },
    },
    {
      name: "id",
      label: "キャンペーンID" ,
      options: {
        filter: true,
        sort: true,
        sortCompare: sortStringToNumber,
        setCellProps: () => ({style: {minWidth: "10rem"}}),
      },
    },
    {
      name: "platformName",
      label: "メニュー",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
      },
    },
    {
      name: "campaignType",
      label: "キャンペーン種別",
      options: {
        filter: true,
        sort: true,
        customBodyRenderLite: idx => {
          return (
            <Chip
              label={
                <Typography variant="subtitle1">
                  {tableData[idx].campaignType}
                </Typography>
              }
              style={
                {backgroundColor: tableData[idx].colorCode, color: 'white', height: "100%"}
              }
            />
          )
        }
      },
    },
    {
      name: "pmpType",
      label: "取引形式",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({style: {minWidth: "10rem"}}),
      }
    },
    {
      name: "platformCampaignName",
      label: "キャンペーン名",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({style: {minWidth: "10rem"}}),
        customBodyRenderLite: (idx: number) => {
          const platformAccountId = tableData[idx].platformAccountId
          const campaignId = tableData[idx].id
          return (
            <Tooltip title="広告グループ一覧" placement="top">
              {
                tableData[idx].platformId === PLATFORM_TYPE.ZEUS ?
                  <Link
                    to={`${adgroups_path}zeus/${accountGroupId}/${accountId}/${platformAccountId}?campaignId=${campaignId}`}>
                    {tableData[idx].platformCampaignName}
                  </Link>
                  :
                  tableData[idx].platformId === PLATFORM_TYPE.MS ?
                    // MS
                    <Link
                      to={`${adgroups_path}ms/${accountGroupId}/${accountId}/${platformAccountId}?campaignId=${campaignId}`}>
                      {tableData[idx].platformCampaignName}
                    </Link>
                    :
                    <></>
              }
            </Tooltip>
          )
        },
      },
    },
    {
      name: "",
      label: "",
      options: {
        filter: false,
        sort: false,
        apolloColumnId: "trigger",
        display: !IsAuthorization(APOLLO_GROUP_OPERATOR, APOLLO_SYSTEM_ADMIN)
          ? 'excluded'
          : true,
        setCellProps: () => ({style: {minWidth: "8rem", textAlign: "center"}}),
        customBodyRenderLite: (idx: number) => {
          const rowData = tableData[idx]
          if (rowData.status === 3) return ("");
          return (
            <Switch
              checked={rowData.status === 1 ? true : false}
              onChange={(event, checked) => handleStatusChange(checked, tableData[idx])}
              color="primary"
            ></Switch>
          );
        }
      } as any,
    },
    {
      name: "status",
      label: "ステータス",
      options: {
        filter: true,
        filterList: columnFilterForStatus,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => valueToLabel(value, options_state_edit),
      },
    },
    {
      name: "campaignGoal",
      label: "キャンペーンの目的",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
      },
    },
    {
      name: "chargeType",
      label: "課金種別",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
      },
    },
    {
      name: "budgetLimit",
      label: "日予算",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value: number) => "¥" + value.toLocaleString(),
        setCellProps: () => ({style: {minWidth: "8rem"}}),
      },
    },
    {
      name: "deliveryPeriod",
      label: "掲載期間",
      options: {
        filter: false,
        sort: true,
        sortCompare: (order: string,) => {
          return (obj1: any, obj2: any) => {
            let val1: string = "";
            let val2: string = "";
            const starAtLocal1 = tableData[obj1.position]?.startAt?.replace(DATE_TIME_SUFFIX, BLANK) ?? BLANK
            const endAtLocal1 = tableData[obj1.position]?.endAt?.replace(DATE_TIME_SUFFIX, BLANK) ?? BLANK
            if (tableData[obj1.position]?.platformId === 3) {
              if (endAtLocal1 === "") {
                val1 = `${moment(starAtLocal1).format('YYYYMMDDHHmm')}`
              } else {
                val1 = `${moment(starAtLocal1).format('YYYYMMDDHHmm')}${moment(endAtLocal1).format('YYYYMMDDHHmm')}`
              }
            } else if (tableData[obj1.position]?.platformId === 1) { 
              if (endAtLocal1 === "") {
                val1 = `${moment(starAtLocal1).format('YYYYMMDD')}`
              } else {
                val1 = `${moment(starAtLocal1).format('YYYYMMDD')}${moment(endAtLocal1).format('YYYYMMDD')}`
              }
            } else {
              val1 = `${moment(starAtLocal1).format('YYYYMMDD')}${moment(endAtLocal1).format('YYYYMMDD')}`
            }

            const starAtLocal2 = tableData[obj2.position]?.startAt?.replace(DATE_TIME_SUFFIX, BLANK) ?? BLANK
            const endAtLocal2 = tableData[obj2.position]?.endAt?.replace(DATE_TIME_SUFFIX, BLANK) ?? BLANK
            if (tableData[obj2.position]?.platformId === 3) {
              if (endAtLocal2 === "") {
                val2 = `${moment(starAtLocal2).format('YYYYMMDDHHmm')}`
              } else {
                val2 = `${moment(starAtLocal2).format('YYYYMMDDHHmm')}${moment(endAtLocal2).format('YYYYMMDDHHmm')}`
              }
            } else if (tableData[obj2.position]?.platformId === 1) { 
              if (endAtLocal2 === "") {
                val2 = `${moment(starAtLocal2).format('YYYYMMDD')}`
              } else {
                val2 = `${moment(starAtLocal2).format('YYYYMMDD')}${moment(endAtLocal2).format('YYYYMMDD')}`
              }
            } else {
              val2 = `${moment(starAtLocal2).format('YYYYMMDD')}${moment(endAtLocal2).format('YYYYMMDD')}`
            }

            return val1.localeCompare(val2, 'ja') * (order === 'asc' ? 1 : -1);
          };
        },
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRenderLite: (idx: number) => {
          const starAtLocal = tableData[idx]?.startAt?.replace(DATE_TIME_SUFFIX, BLANK) ?? BLANK
          const endAtLocal = tableData[idx]?.endAt?.replace(DATE_TIME_SUFFIX, BLANK) ?? BLANK
          if (tableData[idx]?.platformId === 1) {
            if (endAtLocal === "") {
              return `${moment(starAtLocal).format('YYYY/MM/DD')} -`
            } else {
              return `${moment(starAtLocal).format('YYYY/MM/DD')} - ${moment(endAtLocal).format('YYYY/MM/DD')}`
            }
          }
          return `${moment(starAtLocal).format('YYYY/MM/DD')} - ${moment(endAtLocal).format('YYYY/MM/DD')}`
        }
      },
    },
    {
      name: "targetCpa",
      label: "目標CPA",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRenderLite: (idx: number) => {
          return tableData[idx].platformId === PLATFORM_TYPE.ZEUS ? "¥" + tableData[idx].targetCpa.toLocaleString() : "-"
        }
      },
    },
    {
      name: "domainSetting",
      label: "配信先ドメイン設定",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRenderLite: (idx: number) => {
          const row = tableData[idx]
          if (row.platformId !== PLATFORM_TYPE.ZEUS) return "-"
          if (row.campaignType === "Performance") return "-"
          if (row.domainSetting === ZEUS_DOMAIN_SETTING.DOMAIN_EXCLUSION) {
            return "除外"
          } else if (row.domainSetting === ZEUS_DOMAIN_SETTING.DOMAIN_SPECIFICATION) {
            return "指定"
          } else{
            return "設定なし"
          }
        }
      },
    },
    {
      name: "cost",
      label: "cost",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => "¥" + value.toLocaleString(),
      }
    },
    {
      name: "imp",
      label: "imp",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => value.toLocaleString(),
      }
    },
    {
      name: "vimp",
      label: "vimp",
      options: {
        filter: false,
        sort: true,
        display: localStorage.getItem(STORAGE_KEY.INDIVIDUAL_SUMMARY) ? undefined : false,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => value.toLocaleString(),
      }
    },
    {
      name: "click",
      label: "click",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => value.toLocaleString(),
      }
    },
    {
      name: "ctr",
      label: "CTR",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => (Math.floor((Math.round(value * 1000000) / 1000000) * 100 * 100) / 100).toFixed(2) + "%",
      }
    },
    {
      name: "vctr",
      label: "vCTR",
      options: {
        filter: false,
        sort: true,
        display: localStorage.getItem(STORAGE_KEY.INDIVIDUAL_SUMMARY) ? undefined : false,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => (Math.floor((Math.round(value * 1000000) / 1000000) * 100 * 100) / 100).toFixed(2) + "%",
      }
    },
    {
      name: "cpc",
      label: "平均CPC",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => "¥" + value.toLocaleString(),
      }
    },
    {
      name: "cpm",
      label: "CPM",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => "¥" + value.toLocaleString(),
      }
    },
    {
      name: "trackingPointCvTotal",
      label: "CV(合計)",
      options: {
        filter: false,
        sort: true,
        display: localStorage.getItem(STORAGE_KEY.INDIVIDUAL_SUMMARY) ? undefined : false,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => value?.toLocaleString(),
      }
    },
    {
      name: "trackingPointCvClickThrough",
      label: "ラストクリックCV(合計)",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => value?.toLocaleString(),
      }
    },
    {
      name: "trackingPointCvAssist",
      label: "アシストクリックCV(合計)",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => value?.toLocaleString(),
      }
    },
    {
      name: "trackingPointCvrTotal",
      label: "CVR(合計)",
      options: {
        filter: false,
        sort: true,
        display: localStorage.getItem(STORAGE_KEY.INDIVIDUAL_SUMMARY) ? undefined : false,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => (Math.floor((Math.round(value * 1000000) / 1000000) * 100 * 100) / 100).toFixed(2) + "%",
      }
    },
    {
      name: "trackingPointCvrClickThrough",
      label: "ラストクリックCVR(合計)",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => (Math.floor((Math.round(value * 1000000) / 1000000) * 100 * 100) / 100).toFixed(2) + "%",
      }
    },
    {
      name: "trackingPointCvrAssist",
      label: "アシストクリックCVR(合計)",
      options: {
        filter: false,
        sort: true,
        display: localStorage.getItem(STORAGE_KEY.INDIVIDUAL_SUMMARY) ? undefined : false,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => (Math.floor((Math.round(value * 1000000) / 1000000) * 100 * 100) / 100).toFixed(2) + "%",
      }
    },
    {
      name: "trackingPointCpaTotal",
      label: "CPA(合計)",
      options: {
        filter: false,
        sort: true,
        display: localStorage.getItem(STORAGE_KEY.INDIVIDUAL_SUMMARY) ? undefined : false,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => "¥" + value?.toLocaleString(),
      }
    },
    {
      name: "trackingPointCpaClickThrough",
      label: "ラストクリックCPA(合計)",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => "¥" + value?.toLocaleString(),
      }
    },
    {
      name: "trackingPointCpaAssist",
      label: "アシストクリックCPA(合計)",
      options: {
        filter: false,
        sort: true,
        display: localStorage.getItem(STORAGE_KEY.INDIVIDUAL_SUMMARY) ? undefined : false,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => "¥" + value?.toLocaleString(),
      }
    },
    {
      name: "lastCvTotal",
      label: "最適化ポイントCV",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => value?.toLocaleString(),
      }
    },
    {
      name: "lastCvrTotal",
      label: "最適化ポイントCVR",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => (Math.floor((Math.round(value * 1000000) / 1000000) * 100 * 100) / 100).toFixed(2) + "%",
      }
    },
    {
      name: "lastCpaTotal",
      label: "最適化ポイントCPA",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => "¥" + value?.toLocaleString(),
      }
    },
  ];

  useEffect(() => {
    saveApolloSharedCalendar(startDate, endDate);
  }, [startDate, endDate]);

  useEffect(() => {
    if (!isSetPointsLoaded && !isPushStatusToggle) return;
    if (startDate === currentBeforeDate.current.startDate && endDate === currentBeforeDate.current.endDate && !isPushStatusToggle && !editCampaign.id) return;
    setProgress(true);
    setIsChartDataLoaded(false);
    setmsg({
      type: "loading",
      payload: {
        ...data,
        loading: true
      }
    })
    const url = `${apollo_campaign_performances}/${accountId}?Start=${startDate}&End=${endDate}`
    ApolloAxios.get(url).then((response) => {
      if (!response.data.result.tableData) {
        setTableData([])
      } else {
        const tableData: PlatformCampaignTableRow[] = response.data.result.tableData
        setTableData(tableData.map((elem => {
          let retElem = elem
          if (elem.platformId === 2) {
            const apolloStatus =
              elem.status === 2 ? 1　//有効（MS=2　→　Apollo=1）
                : elem.status === 3 ? 2　//一時停止（MS=4　→　Apollo=2）
                  : elem.status === 6 ? 3　//アーカイブ（MS=6　→　Apollo=3）
                    : 1
            retElem = {...elem, status: apolloStatus}
          }
          return retElem
        })))
        const MSRtmCampaigns = tableData.filter(v => (v.campaignType === "リアルタイムメッセージS" && v.platformId === PLATFORM_TYPE.MS))
        if(MSRtmCampaigns.length > 0){
          setHasMSRtmCampaign(true)
        }
      }
      if (!response.data.result.chartData) {
        setChartRawData([])
      } else {
        setChartRawData(response.data.result.chartData)
      }
      if (!response.data.result.reflectAt) {
        setReflectAt("")
      } else {
        setReflectAt(response.data.result.reflectAt)
      }
      currentBeforeDate.current = {startDate: startDate, endDate: endDate,}
    }).catch(err => {
      console.log(err)
      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, GetMessage("0",UI_INDIVIDUAL_SUMMARY,"E","0"), data, setmsg, history)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
    }).finally(() => {
      setIsPushStatusToggle(false);
      setFetchPreviousDataStart(fetchPreviousDataStart + 1);
      setmsg({
        type: "loading",
        payload: {
          ...data,
          loading: false
        }
      })
      setProgress(false);
    });
  }, [startDate, endDate, updateListCnt, isSetPointsLoaded]);

  useEffect(() => {
    if (fetchPreviousDataStart === 0) return;
    if (startDate === previousBeforeDate.current.startDate && endDate === previousBeforeDate.current.endDate) return;
    if (isPreviousPeriodChecked) {
      setIsPreviousPeriodDisabled(true);
      setmsg({
        type: "loading",
        payload: {
          ...data,
          loading: true
        }
      })
      const start = moment(startDate);
      const end = moment(endDate);
      const diffDays = end.diff(start, 'days') + 1;
      const previousStart = start.subtract(diffDays, 'days').format('YYYY-MM-DD');
      const previousEnd = end.subtract(diffDays, 'days').format('YYYY-MM-DD');
      setPreviousStartDate(previousStart);
      setPreviousEndDate(previousEnd);
      const url = `${apollo_campaign_performances}/${accountId}?Start=${previousStart}&End=${previousEnd}`
      ApolloAxios.get(url).then((response) => {
        if (!response.data.result.chartData) {
          setPreviousChartRawData([])
        } else {
          setPreviousChartRawData(response.data.result.chartData)
        }
        previousBeforeDate.current = {startDate: startDate, endDate: endDate,}
      }).catch(err => {
        console.log(err)
        // 認証期間切れ判定とエラーメッセージ表示
        if (!ApolloExpired(err, GetMessage("0",UI_INDIVIDUAL_SUMMARY,"E","0"), data, setmsg, history)) {
          // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
        }
      }).finally(() => {
        setmsg({
          type: "loading",
          payload: {
            ...data,
            loading: false
          }
        })
        setIsChartDataLoaded(true);
        setIsPreviousPeriodDisabled(false);
      });
    } else {
      setmsg({
        type: "loading",
        payload: {
          ...data,
          loading: false
        }
      })
    }
  }, [fetchPreviousDataStart, isPreviousPeriodChecked]);

  useEffect(() => {
    setIsSetPointsLoaded(false);

    const fetchSetPoints = () => {
      const url = `${process.env.REACT_APP_API_ENDPOINT}${apollo_setpoints_path}/${accountId}`;
      ApolloAxios.get(url).then((response) => {
        if (response.data?.resultCode === RESULT_SETPOINT_ERROR) {
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: `${MSG.ERROR_GET_SET_POINTS}${response?.data?.message ?? BLANK}`
            }
          });
        } else if (response.data.result) {
          const newSetPoints: Option[] = [];
          const newDeletedSetPoints: Option[] = [];
          response.data?.result?.map(function (data: { setPointId: number, setPointName: string, setPointDeleteFlg: number }) {
            if (data.setPointDeleteFlg === 0) {
              const option: Option = {
                value: data.setPointId,
                label: `${data.setPointId}${UNDER_SCORE}${data.setPointName}`,
              }
              newSetPoints.push(option);
            } else {
              const option: Option = {
                value: data.setPointId,
                label: `${data.setPointId}${UNDER_SCORE}${data.setPointName}（削除済み）`,
              }
              newDeletedSetPoints.push(option);
            }
          });
          setSetPoints(newSetPoints);
          setDeletedSetPoints(newDeletedSetPoints);
        }
      }).catch(err => {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: `${MSG.ERROR_GET_SET_POINTS}${err?.errmsg ?? BLANK}`
          }
        });
      }).finally(() => {
        setmsg({
          type: "loading",
          payload: {
            ...data,
            loading: false
          }
        })
        setIsSetPointsLoaded(true);
      });
    }

    const fetchAll = async () => {
      await Promise.all(
        [fetchSetPoints()]
      ).finally(() => {
      })
    }

    fetchAll();

  }, [accountId]);

  // useEffect(() => {
  //   if (!tableData || tableData.length <= 0 || isDemographicDataLoaded) return
  //   const date = moment().add(-1, 'day').format('YYYY-MM-DD');
  //   var targets:string[] = [];
  //   for (let data of tableData) {
  //     targets.push(`${data.platformId}${UNDER_SCORE}${data.id}`);
  //   }
  //   const fetchData = () => {
  //     const url = `${apollo_demographic_performances}/${accountId}?Date=${date}&Kind=${PERFORMANCE_KIND.CAMPAIGN}&Target=${targets.join(COMMA)}`
  //     ApolloAxios.get(url).then((response) => {
  //       if (!response.data.result.demographicData) {
  //         setDemographicRawData([])
  //       } else {
  //         setDemographicRawData(response.data.result.demographicData)
  //         setReferenceDate(response.data.result.referenceDate)
  //       }
  //     }).catch(err => {
  //       console.log(err)
  //       // 認証期間切れ判定とエラーメッセージ表示
  //       if (!ApolloExpired(err, GetMessage("0",UI_INDIVIDUAL_SUMMARY,"E","0"), data, setmsg, history)) {
  //         // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
  //       }
  //     }).finally(() => {
  //     });
  //   }

  //   const fetchAll = async () => {
  //     await Promise.all(
  //       [fetchData()]
  //     ).finally(() => {
  //       setIsDemographicDataLoaded(true);
  //     })
  //   }
  //   fetchAll();
  // }, [tableData]);

  const createOptions = () => {
    var local_grouped_options: GroupedOption[] = []
    var local_colored_options: ColoredOption[] = []

    var opt: ColoredOption = {
      value: ALL,
      label: SELECT_ALL,
      color: "",
    }
    local_colored_options.push(opt);

    var groupedOption: GroupedOption = {
      value: BLANK,
      label: BLANK,
      options: local_colored_options,
    }
    local_grouped_options.push(groupedOption);

    if (tableData && tableData.length > 0) {
      for (let menu of options_menu_kind) {
        var local_colored_options: ColoredOption[] = []
        tableData.forEach((campaign, index) => {
          if (menu.value === campaign.platformId) {
            var opt: ColoredOption = {
              value: `${index}`,
              label: `${campaign.id}${UNDER_SCORE}${campaign.platformCampaignName}`,
              color: menu.color,
            }
            local_colored_options.push(opt);
          }
        });

        var groupedOption: GroupedOption = {
          value: BLANK,
          label: menu.label,
          options: local_colored_options,
        }
        local_grouped_options.push(groupedOption)
      }
    }

    return local_grouped_options;
  }

  const onChangeOption = (selectedOptions: any[]) => {
    if (!selectedOptions || selectedOptions[selectedOptions.length - 1].value === ALL) {
      setSelectedValues([...options_select_all])
      setFilterValues([ALL])
    } else {
      selectedOptions = selectedOptions.filter(v => v.value !== ALL)
      selectedOptions = sortByUnderscoreParts(selectedOptions);
      setSelectedValues(selectedOptions);
      const setVals = selectedOptions.map((target: any) => {
        return target.value
      })
      setFilterValues(setVals)
    }
  };

  const pfCampaignInfo = React.useRef<PlatformCampaignTableRow>(initEditCampaign);
  const newStatusInfo = React.useRef(-1);
  const resultApi = React.useRef(-1);

  /** ステータス変更 */
  const handleStatusChange = async(checked: boolean, row: PlatformCampaignTableRow) => {
    setProgress(true);
    setmsg({
      type: "loading",
      payload: {
        ...data,
        loading: true
      }
    })

    const newStatus = checked ? 1 : 2
    const platformId = row.platformId

    // 操作ログ出力(編集)
    pfCampaignInfo.current = row;
    newStatusInfo.current = newStatus;
    resultApi.current = 0;
    writeLog();

    if (platformId === 1) {
      // Zeus
      await updateStatusZeus(row, newStatus);
    } else if (platformId === 2) {
      // MS
      await updateStatusMs(row, newStatus === 1 ? 2 : 3);
    }

    // 操作ログ出力(結果)
    writeLog();

    if (resultApi.current === 1) {
      setIsPushStatusToggle(true)
      setUpdateListCnt(updateListCnt + 1)
    } else {
      setmsg({
        type: "loading",
        payload: {
          ...data,
          loading: false
        }
      })
      setProgress(false);
    }
  }

  /** ステータス変更(Zeus) */
  const updateStatusZeus = async(row: PlatformCampaignTableRow, status: number) => {
    let isError = false;
    let campaignZeus: CampaignZeus = {
      id: 0,
      createdAt: "",
      updatedAt: "",
      lastUpdateUserId: 0,
      adAccountId: 0,
      billingType: 1,
      pmpType: null,
      fqExist: false,
      fqClass: 1,
      fqTerm: 1,
      fqCount: 1,
      fqType: 1,
      budgetAllocation: 1,
      domainSetting: 0,
      deliveryType: 1,
      name: "",
      status: 2,
      budgetLimitDaily: 1,
      schedule: "",
      startDate: "",
      endDate: "",
      campaignGoal: 1,
      cpa: 1,
      autoBidding: false,
      extAdCampaignBudgetProportion: 0,
      excludingAudiences: [],
      adCampaignExcludingDomains: [],
      adCampaignTargetDomains: [],
      trackingPoints: [],
    };

    const getUrl = `${process.env.REACT_APP_API_ENDPOINT}${get_zeus_campaign_path}/${row.id}`
    await ApolloAxios.get(getUrl).then(response => {
      if (response.status !== 200) {
        isError = true;
        return Promise.reject({
          open: true,
          type: "error",
          errmsg: "キャンペーン情報取得に失敗しました。",
        });
      }

      response.data.startDate = null
      campaignZeus = {
        ...cloneDeep(response.data)
      }
    }).catch(err => {
      isError = true;
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: err.type,
          message: err.errmsg,
        }
      });
    });

    if (isError) return;

    const patchUrl = `${patch_zeus_campaign_path}/${row.id}`
    const body = {
      ...cloneDeep(campaignZeus),
      status: status,
    }
    await ApolloAxios.patch(patchUrl, body).then(response => {
      if (response.status !== 200) {
        // 操作ログ(失敗)
        resultApi.current = 9;
        return Promise.reject({
          open: true,
          type: "error",
          errmsg: "ステータス更新に失敗しました。",
        });
      }
      // 操作ログ(成功)
      resultApi.current = 1;
    }).catch(err => {
      // 操作ログ(失敗)
      resultApi.current = 9;
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: err.type,
          message: err.errmsg,
        }
      });
    });
  }

  /** ステータス変更(MS) */
  const updateStatusMs = async(row: PlatformCampaignTableRow, status: number) => {
    let isError = false;
    let campaign: Campaign = {
      id: 0,
      createdAt: "",
      updatedAt: "",
      lastUpdateUserId: 0,
      adAccountId: 0,
      name: "",
      status: 3,
      campaignType: 1,
      budgetLimitDaily: null,
      schedule: "",
      startDate: "",
      endDate: "",
      cpa: null,
      billingType: -1,
      /*　リリース時期未定のため、無効化しておく。
          excludingAudiences: [],
      */
      trackingPoints: [],
      lastUpdatedVer: "",
    }

    if (row.campaignType == "リアルタイムメッセージS") {
      isError = true;
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: `${"リアルタイムメッセージSのキャンペーンのステータスは変更できません。"}`,
        }
      });
    }
    if (isError) return;

    const getUrl = `${process.env.REACT_APP_API_ENDPOINT}${get_ms_campaign_path}/${row.platformAccountId}/${row.id}`
    await ApolloAxios.get(getUrl).then(response => {
      if (response.data.resultcode !== 0) {
        isError = true;
        return Promise.reject({
          open: true,
          type: "error",
          errmsg: `${"キャンペーン情報取得に失敗しました。"}${response?.data?.message ?? BLANK}`,
        });
      }

      campaign = {
        ...cloneDeep(response.data.result)
      }
    }).catch(err => {
      isError = true;
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: `${"キャンペーン情報取得に失敗しました。"}${err?.errmsg ?? BLANK}`
        }
      });
    });

    if (isError) return;

    const putUrl = `${process.env.REACT_APP_API_ENDPOINT}${put_ms_campaign_path}`
    const campaignUpdate: CampaignUpdate = {
      ...cloneDeep(campaign),
      adAccountId: campaign.adAccountId,
      campaignId: campaign.id,
      campaignName: campaign.name,
      campaignStatus: status,
      distributionStart: campaign.startDate,
      distributionEnd: campaign.endDate ?? BLANK,
      cpd: Number(campaign.budgetLimitDaily),
      targetCpa: campaign.cpa ? Number(campaign.cpa) : null,
      distributionScd: campaign.schedule,
      /*
      リリース時期未定のため、無効化しておく。
      excludingAudience: campaign.excludingAudiences,
      */
      campaignTrackingPoint: campaign.trackingPoints,
      userId: state.userprofile.userId.toString(),
    }
    await ApolloAxios.put(putUrl, campaignUpdate).then(response => {
      if (!isSuccessApi(response.data.resultcode)) {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: response.data?.message ?? "ステータス更新に失敗しました。"
          }
        });
        // 操作ログ(失敗)
        resultApi.current = 9;
        return;
      }
      // 操作ログ(成功)
      resultApi.current = 1;
    }).catch(err => {
      // 操作ログ(失敗)
      resultApi.current = 9;
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: err.type,
          message: err.errmsg,
        }
      });
    });
  }

  /** 操作ログ出力 */
  const writeLog = () => {
    if (resultApi.current < 0) return;

    const itemList: ItemList[] = [
      {
        key: "ステータス",
        beforeValue: valueToOption(pfCampaignInfo.current.status, options_state_edit).label + "",
        afterValue: valueToOption(newStatusInfo.current, options_state_edit).label + "",
      },
    ]

    const executionLog: LogData = {
      eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
      logType: resultApi.current === 0 ? "execute" : "result",
      result: resultApi.current === 0 ? "" : resultApi.current === 1 ? "成功" : "失敗",
      userID: state.userprofile.userId,
      userName: state.userprofile.userName,
      accessToken: state.accesstoken,
      accountGroupID: state.current.accountGroupId,
      accountGroupName: state.current.accountGroupName,
      accountID: state.current.accountId,
      accountName: state.current.accountName,
      campaignID: pfCampaignInfo.current.id + "",
      campaignName: pfCampaignInfo.current.platformCampaignName + "",
      adGroupID: "",
      adGroupName: "",
      menu: pfCampaignInfo.current.platformId === 1 ? "パフォーマンス広告" : pfCampaignInfo.current.platformId === 2 ? "メール広告" : "",
      displayName: "キャンペーン一覧画面",
      category: "キャンペーン",
      actionType: "更新",
      targetID: pfCampaignInfo.current.id + "",
      targetName: pfCampaignInfo.current.platformCampaignName + "",
      itemList: itemList,
    }

    // 操作ログ出力
    ApolloEventRecord(executionLog);
  };

  const [progress, setProgress] = useState(true);


  const options: DataTableOptions = {
    print: false,
    downloadOptions: {
      filename: `campaigns_${moment(startDate).format("YYYYMMDD")}_${moment(endDate).format("YYYYMMDD")}.csv`,
      separator: ",",
      filterOptions: {
        useDisplayedColumnsOnly: false,
        useDisplayedRowsOnly: true,
      }
    },
    onDownload: (buildHead: any, buildBody: any, columns: any, data: any) => {
      const csvData = formatCsvData(data, tableData, setPoints, deletedSetPoints);
      return "\uFEFF" + buildHead(generateCsvHeader(CampaignColumns, setPoints, deletedSetPoints)) + buildBody(csvData);
    },
    elevation: 0,
    sortOrder: localStorage.getItem(STORAGE_KEY.INDIVIDUAL_SUMMARY) ? undefined : sortOrder,
    selectToolbarPlacement: "above",
    filterType: "multiselect",
    storageKey: STORAGE_KEY.INDIVIDUAL_SUMMARY,
    customToolbarSelect: () => undefined,
    onFilterChange: (changedColumn, filterList, type, changedColumnIndex) => {
      if(changedColumn === "status") {
        setColumnFilterForStatus(filterList[changedColumnIndex]);
      }
    },
    onColumnSortChange: (changedColumn: string, direction: string) => {
      setSortOrder({
        name: changedColumn,
        direction: direction,
      } as MUISortOptions)
    },
  }

  // 表で使用するパラメータをMemo化
  const chartRawDataMemo =  useMemo(() => chartRawData.map(value => value.performances), [filterValues, chartRawData, previousChartRawData]);
  const previousChartRawDataMemo =  useMemo(() => previousChartRawData.map(value => value.performances), [filterValues, chartRawData, previousChartRawData]);
  const columnsMemo =  useMemo(() => applyApolloSharedColumnSettings(
    generateColumns(columns, STORAGE_KEY.INDIVIDUAL_SUMMARY, setPoints, deletedSetPoints),
    {pageId: APOLLO_PAGE_ID.CAMPAIGN, accountGroupId, data: tableData}
  ), [tableData, drawerState, columnFilterForStatus, setPoints, deletedSetPoints, accountGroupId]);
  const optionsMemo: DataTableOptions = useMemo(() => createApolloSharedTableOptions({
    print: false,
    downloadOptions: {
      filename: `campaigns_${moment(startDate).format("YYYYMMDD")}_${moment(endDate).format("YYYYMMDD")}.csv`,
      separator: ",",
      filterOptions: {
        useDisplayedColumnsOnly: false,
        useDisplayedRowsOnly: true,
      }
    },
    onDownload: (buildHead: any, buildBody: any, columns: any, data: any) => {
      const csvData = formatCsvData(data, tableData, setPoints, deletedSetPoints);
      return "\uFEFF" + buildHead(generateCsvHeader(CampaignColumns, setPoints, deletedSetPoints)) + buildBody(csvData);
    },
    elevation: 0,
    sortOrder: localStorage.getItem(STORAGE_KEY.INDIVIDUAL_SUMMARY) ? undefined : sortOrder,
    selectToolbarPlacement: "above",
    filterType: "multiselect",
    storageKey: STORAGE_KEY.INDIVIDUAL_SUMMARY,
    jumpToPage: true,
    rowsPerPageOptions: ROW_PER_PAGE_OPTIONS.HOME_AND_MAIN_LEVELS,
    customToolbarSelect: () => undefined,
    onFilterChange: (changedColumn, filterList, type, changedColumnIndex) => {
      if(changedColumn === "status") {
        setColumnFilterForStatus(filterList[changedColumnIndex]);
      }
    },
    onColumnSortChange: (changedColumn: string, direction: string) => {
      setSortOrder({
        name: changedColumn,
        direction: direction,
      } as MUISortOptions)
    },
  }, {
    pageId: APOLLO_PAGE_ID.CAMPAIGN,
    accountGroupId,
    columns: columnsMemo,
  }), [tableData, setPoints, deletedSetPoints, columnsMemo, accountGroupId])
  const setpointMemo =  useMemo(() => mergeOptions(setPoints, deletedSetPoints), [setPoints, deletedSetPoints]);
  const titleMemo = useMemo(() =>
      <React.Fragment>
        {state.isUseForDisplayAdsOnly ||
            <ApolloUserProfileAuth role={APOLLO_GROUP_OPERATOR} profile={APOLLO_SYSTEM_ADMIN}>
              <Tooltip title="キャンペーン新規作成" placement="bottom">
                <Link to="#" onClick={() => setOpenDialog(true)} className={classes.link}>
                  <Fab size="small" color="primary" aria-label="add" style={{marginTop: "10px"}}>
                    <AddIcon/>
                  </Fab>
                </Link>
              </Tooltip>
            </ApolloUserProfileAuth>
        }
        <p style={{fontSize: "15px"}}>
          {
              "実績値取得日時: " +
              (
                  reflectAt
                      ? moment(reflectAt.replace(DATE_TIME_SUFFIX, BLANK)).format("YYYY-MM-DD HH:mm:ss")
                      : BLANK
              )
          }
        </p>
      </React.Fragment>, [reflectAt])

  return (
    <GenericTemplate title="">
      <Backdrop className={classes.backdrop2} open={progress}>
        <Bars color="#00BFFF" height={80} width={80} />
      </Backdrop>
      <CustomizedSnackbars/>
        <Grid container spacing={1} justify="flex-end">
          <Grid item xs={12}>
            <ApolloBreadcrumbs2 data={breadcrumbsData}/>
          </Grid>

          <Grid item xs={12}>
            <CostPage/>
          </Grid>

          <Grid item xs={4} md={4} style={{ display: 'flex', alignItems: 'flex-end' }}>
            <ApolloDateRangePicker
              startDate={startDate}
              setStartDate={setStartDate}
              endDate={endDate}
              setEndDate={setEndDate}
              {...(!isAuthorization && { startMinDate: new Date("2025-10-01T00:00:00") })}
            />
          </Grid>

          <Grid item xs={4} md={4}>
            <InputLabel id="graph-display-select">
              <Typography variant="caption">
              グラフ表示対象の選択
              </Typography>
            </InputLabel>
            <div>
              <Select
                menuPosition={'fixed'}
                closeMenuOnSelect={false}
                isMulti
                isSearchable
                value={selectedValues}
                onChange={onChangeOption}
                options={createOptions()}
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    maxHeight: "70px", overflowY: "scroll"
                  }),
                  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
                    return {
                      ...styles,
                      backgroundColor: isDisabled
                      ? undefined
                      : isSelected
                      ? data.color
                      : isFocused
                      ? "#BCD4FF"
                      : undefined,
                      color: isDisabled
                        ? '#ccc'
                        : data.color,
                      cursor: isDisabled ? 'not-allowed' : 'default',
                      ':active': {
                        ...styles,
                        backgroundColor: !isDisabled
                          ? data.color
                          : isSelected,
                      },
                    };
                  },
                  multiValue: (styles, { data }) => {
                    return {
                      ...styles,
                    };
                  },
                  multiValueLabel: (styles, { data }) => ({
                    ...styles,
                    color: data.color,
                  }),
                  multiValueRemove: (styles, { data }) => ({
                    ...styles,
                    color: data.color,
                    ':hover': {
                      backgroundColor: data.color,
                      color: 'white',
                    },
                  }),
                  menuPortal: base => ({...base, zIndex: 9999}),
                }}
              />
            </div>
          </Grid>

          <Grid item xs={4} md={4}>
          </Grid>
        </Grid>
        <ApolloPerformanceMemo
          startDate={startDate}
          endDate={endDate}
          previousStartDate={previousStartDate}
          previousEndDate={previousEndDate}
          dailyPerformanceData={chartRawDataMemo}
          previousDailyPerformanceData={previousChartRawDataMemo}
          // demographicPerformanceData={demographicRawData.map(value => demographicDisplayPeriod === DEMOGRAPHIC_DISPLAY_PERIOD.LAST_MONTH ? value.performancesLastMonth : value.performancesLastWeek)}
          selectedValues={filterValues}
          data={tableData}
          columns={columnsMemo}
          options={optionsMemo}
          storageKeyGraph1={LintChartStorageKey.IndividualSummaryGraph1}
          storageKeyGraph2={LintChartStorageKey.IndividualSummaryGraph2}
          // storageKeyDemographicGraph={BarChartStorageKey.IndividualSummaryGraph}
          fileName={`chart_campaigns_${moment(startDate).format("YYYYMMDD")}_${moment(endDate).format("YYYYMMDD")}.csv`}
          // histogramFileName={`histogram_campaigns_YYYYMMDD_YYYYMMDD.csv`}
          isPreviousPeriodChecked={isPreviousPeriodChecked}
          setIsPreviousPeriodChecked={setIsPreviousPeriodChecked}
          isPreviousPeriodDisabled={isPreviousPeriodDisabled}
          isChartDataLoaded={isChartDataLoaded}
          // demographicDisplayPeriod={demographicDisplayPeriod}
          // setDemographicDisplayPeriod={setDemographicDisplayPeriod}
          // statementFlag={true}
          setPoints={setpointMemo}
          // referenceDate={referenceDate}
          title={titleMemo}
        />
        <SelectMenu pathTop={campaignedit_path} pathEnd={""} open={openDialog} setOpen={setOpenDialog} />

      <RightDrawer>
        <CampaignEdit editCampaign={editCampaign} listReloadFunc={listReloadFunc}/>
      </RightDrawer>
    </GenericTemplate>
  );
};

type CampaignEditProps = {
  editCampaign: PlatformCampaignTableRow,
  listReloadFunc: any,
}

const CampaignEdit: React.FC<CampaignEditProps> = ({editCampaign,listReloadFunc}) => {

  return (
    <>
      {editCampaign.platformId === 1
        ?
        <CampaignEditZeus
          platformAccountId={editCampaign.platformAccountId}
          campaignId={toNumber(editCampaign.id)}
          listReloadFunc={listReloadFunc}
        />
        :
        editCampaign.platformId === 2
          ?
          <CampaignEditMs
            platformAccountId={editCampaign.platformAccountId}
            campaignId={toNumber(editCampaign.id)}
            listReloadFunc={listReloadFunc}
          />
          :
          null
      }
    </>
  )

}

const CostPage: React.FC = () => {
  const classes = apollo_useStyles();
  const {state} = useContext(ApolloContext);
  const {data, setmsg} = useContext(ApolloMessage);

  const accountId = state.current.accountId
  const accountGroupId = state.current.accountGroupId

  // true: 当月, false: 前月
  const [isThisMonth, setIsThisMonth] = useState(true)

  const useStyles = makeStyles((theme) => ({
    typography: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
    },
  }));
  const classesLocal = useStyles();

  const themeLocal = createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 1250,
        lg: 1650,
        xl: 1920,
      },
    },
  })

  // example: 202109
  const yearMonth = isThisMonth ? moment().format("YYYYMM") : moment().add(-1, "months").format("YYYYMM")

  const initAccountBudgetCostPerformance: AccountBudgetCostPerformance = {
    accountId: 0,
    budgetMonth: "",
    budgetAmount: 0,
    nextBudgetAmount: 0,
    cost: 0,
    budgetCostPerformance: [],
  }

  const [accountBudgetCostPerformance, setAccountBudgetCostPerformance] = useState<AccountBudgetCostPerformance>(initAccountBudgetCostPerformance)
  // リダイレクト(認証期間切れの場合にリダイレクトするため)
  const history = useHistory();
  const [isQuasiResvDisplay, setQuasiResvDisplay] = useState(false);

  useEffect(() => {

    const urlAccountBudgetCostPerformances = `${apollo_account_budget_cost_performances}/${accountId}/${yearMonth}`;
    const urlAccountPlatformMenu = `${process.env.REACT_APP_API_ENDPOINT}${apollo_account_platform_menu_path}/${accountId}`;

    Promise.all([
      // アカウント別予算実績情報取得
      ApolloAxios.get(urlAccountBudgetCostPerformances),
      // 広告主アカウントメニュー情報取得
      ApolloAxios.get(urlAccountPlatformMenu, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${state.accesstoken}`,
        }
      }),
    ])
      .then(([responseAccountBudgetCostPerformances, responseAccountPlatformMenu]) => {
        // アカウント別予算実績情報を設定
        const result: AccountBudgetCostPerformance = responseAccountBudgetCostPerformances.data.result;
        if (result.budgetCostPerformance) {
          setAccountBudgetCostPerformance({
            ...result,
            budgetCostPerformance: result.budgetCostPerformance.filter(x => x.budgetNo != 10 && x.budgetNo != 22
            )
          });
        }

        const data = responseAccountPlatformMenu.data;
        console.log(data);

        // menuIdが2(メール広告)かつuseStatusが1(利用可)のpfAccountIdを取得
        const targetEntry = data.result.find(
          (entry: any) => entry.menuId === menu_id_number.MAIL && entry.useStatus === use_status_number.AVAILABLE
        );
        const platformAccountId = targetEntry?.pfAccountId;

        if (!platformAccountId) {
          // プラットフォームアカウントIDが取得できない場合、準予約ステータス非表示
          setQuasiResvDisplay(false)
          return null;
        }

        // MSアカウント詳細取得
        const urlGetMsAccount = `${process.env.REACT_APP_API_ENDPOINT}${get_ms_account_path}/${accountGroupId}/${platformAccountId}`;
        return ApolloAxios.get(urlGetMsAccount, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${state.accesstoken}`,
            },
        });
      })
      .then((responseGetMsAccount) => {
        const quasiReservationStatus = responseGetMsAccount?.data.result.quasiReservationStatus;
        // 準予約ステータスが1(有効)の場合、準予約ステータス表示
        setQuasiResvDisplay(quasiReservationStatus === quasi_reservation_state_number.APPROVAL)
      })
      .catch(err => {
        console.log(err);
        // 認証期間切れ判定とエラーメッセージ表示
        if (!ApolloExpired(err, GetMessage("0", UI_INDIVIDUAL_SUMMARY, "E", "0"), data, setmsg, history)) {
          // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
        }
      });
  }, [isThisMonth])

  return (
    <Grid xs={12} spacing={2} alignItems="stretch">
      <Card className={classes.table} variant="outlined">
        <Typography className={classesLocal.typography} variant="button" display="block" align="left">
          <Grid xs={12} container>
            <Grid xs={12} md={4}>
              <Typography variant="h6" color="textSecondary">アカウント消化金額</Typography>
            </Grid>
            <Grid xs={12} md={3}>消化金額</Grid>
            <Grid xs={12} md={1}>¥{accountBudgetCostPerformance.cost?.toLocaleString()}</Grid>
            <Grid xs={12} md={3}>月額予算(予約型を除く)</Grid>
            <Grid xs={12} md={1}>￥{accountBudgetCostPerformance.budgetAmount?.toLocaleString()}</Grid>
          </Grid>
        </Typography>
      </Card>
      <Grid item sm={12} md={12}>
        <Card square variant="outlined" className={classes.root}>
          <CardHeader
            title={<Typography variant="h6" color="textSecondary">キャンペーン種別消化金額</Typography>}
            action={
              isThisMonth
                ?
                <>
                  <Button size="small">当月</Button>
                  <Box display="inline">|</Box>
                  <Button color="primary" size="small" onClick={() => setIsThisMonth(false)}>前月</Button>
                </>
                :
                <>
                  <Button color="primary" size="small" onClick={() => setIsThisMonth(true)}>当月</Button>
                  <Box display="inline">|</Box>
                  <Button size="small">前月</Button>
                </>
            }
          />
          <CardContent>
            <Grid container justify="flex-start">
              {accountBudgetCostPerformance.budgetCostPerformance?.length > 0
                ? accountBudgetCostPerformance.budgetCostPerformance.map(budgetCostPerformance => (
                  <ThemeProvider theme={themeLocal}>
                    <Grid item sm={4} md={3} lg={2}>
                      <Grid container>
                        {(budgetCostPerformance.budgetName === "メッセージS") && isQuasiResvDisplay ?
                          <Grid item xs={12} style={{ marginBottom: 3 }}>
                            <Chip
                              label={
                                <Typography variant="subtitle1">
                                  準予約配信
                                </Typography>
                              }
                              variant="outlined"
                              style={getQuasiReservationIconStyle()}
                            />
                          </Grid> :
                          <Grid item xs={12} style={{ marginBottom: 3 }}>
                            <Chip
                              style={
                                { visibility: "hidden" }
                              }
                            />
                          </Grid>
                        }
                        <Grid item xs={12}>
                          <Chip
                            label={
                              <Typography variant="subtitle1">
                                {budgetCostPerformance.budgetName}
                              </Typography>
                            }
                            style={
                              {
                                backgroundColor: budgetCostPerformance.colorCode,
                                color: 'white',
                                height: "100%",
                                minWidth: "120px",
                                textAlign: "center"
                              }
                            }
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <Grid container justify="center" alignItems="center">
                            <Grid item xs={10}>
                              <Typography variant="subtitle1"
                                          color="textSecondary">消化金額</Typography>
                              <Typography variant="h6" color="textSecondary">
                                ¥{budgetCostPerformance.cost?.toLocaleString()}
                              </Typography>
                            </Grid>
                            <Grid item xs={10}>
                              <Typography variant="caption"
                                          color="textSecondary">
                                月額予算
                              </Typography>
                              <Typography variant="subtitle1" color="textSecondary">
                                {"¥" + budgetCostPerformance.budgetAmount?.toLocaleString()}
                              </Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </ThemeProvider>
                ))
                : <Typography color="textSecondary">該当のキャンペーン種別がありません</Typography>
              }
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  )
}

const formatCsvData = (data: any[], tableData: PlatformCampaignTableRow[], setPoints: Option[], deletedSetPoints: Option[]): CsvData[] => {
  const dataList: CsvData[] = [];
  let mergedSetPoints = [...setPoints, ...deletedSetPoints];
  data?.map((v: { index: any, data: any[] }) => {
      if (!v.data || v.data.length === 0) return;
      const values = tableData.filter((td) => td.id === v.data[1]);
      if (!values || values.length === 0) return;
      const d = values[0];

      let campaignType = d.campaignType;
      if (campaignType === ZEUS_DELIVERY_TYPE_STRING_SHORT.PERFORMANCE) {
        campaignType = ZEUS_DELIVERY_TYPE_STRING.PERFORMANCE;
      } else if (campaignType === ZEUS_DELIVERY_TYPE_STRING_SHORT.DSP) {
        campaignType = ZEUS_DELIVERY_TYPE_STRING.DSP;
      }

      let pmpType = "";
      if (d.platformId === PLATFORM_TYPE.ZEUS) {
        pmpType = "\u2010" //全角ハイフン
        if (d.campaignType === ZEUS_DELIVERY_TYPE_STRING_SHORT.DSP) {
          pmpType = d.pmpType;
        }
      }

      let domainSetting = "";
      if (d.platformId === PLATFORM_TYPE.ZEUS) {
        domainSetting = "\u2010" //全角ハイフン
        if (d.campaignType === ZEUS_DELIVERY_TYPE_STRING_SHORT.DSP) {
          if(d.domainSetting === ZEUS_DOMAIN_SETTING.DOMAIN_EXCLUSION) {
            domainSetting = "除外"
          } else if (d.domainSetting === ZEUS_DOMAIN_SETTING.DOMAIN_SPECIFICATION) {
            domainSetting = "指定"
          }else {
            domainSetting = "設定なし"
          }
        }
      }

      // NOTE:UTC形式の日付ではmoment()実行時にJSTとして誤った計算されるため、タイムゾーンオフセットを削除することでタイムゾーン計算をさせない
      const starAt = d.startAt?.replace(DATE_TIME_SUFFIX, BLANK) ?? BLANK
      const endAt = d.endAt?.replace(DATE_TIME_SUFFIX, BLANK) ?? BLANK

      const list: CsvData = {
        index: v.index,
        data: [
          d.id,
          d.platformName,
          campaignType,
          pmpType,
          d.platformCampaignName,
          valueToLabel(d.status, options_state_edit),
          d.campaignGoal.replace("-", ""),
          d.chargeType,
          `￥${d.budgetLimit}`,
          moment(starAt).format('YYYY/MM/DD HH:mm'),
          endAt? moment(endAt).format('YYYY/MM/DD HH:mm'): "",
          d.platformId === PLATFORM_TYPE.ZEUS ? `¥${d.targetCpa}` : "",
          domainSetting,
          `￥${d.cost}`,
          d.imp,
          d.vimp,
          d.click,
          `${(Math.floor((Math.round(d.ctr * 1000000) / 1000000) * 100 * 100) / 100).toFixed(2)}%`,
          `${(Math.floor((Math.round(d.vctr * 1000000) / 1000000) * 100 * 100) / 100).toFixed(2)}%`,
          `￥${d.cpc}`,
          `￥${d.cpm}`,
          d.trackingPointCvTotal,
          d.trackingPointCvClickThrough,
          ...generateSetPointColumns(d.trackingPointCvClickThroughSetPoints, TRACKING_POINT.CV_CLICK_THROUGH, mergedSetPoints),
          d.trackingPointCvAssist,
          ...generateSetPointColumns(d.trackingPointCvAssistSetPoints, TRACKING_POINT.CV_ASSIST, mergedSetPoints),
          `${(Math.floor((Math.round(d.trackingPointCvrTotal * 1000000) / 1000000) * 100 * 100) / 100).toFixed(2)}%`,
          `${(Math.floor((Math.round(d.trackingPointCvrClickThrough * 1000000) / 1000000) * 100 * 100) / 100).toFixed(2)}%`,
          ...generateSetPointColumns(d.trackingPointCvrClickThroughSetPoints, TRACKING_POINT.CVR_CLICK_THROUGH, mergedSetPoints),
          `${(Math.floor((Math.round(d.trackingPointCvrAssist * 1000000) / 1000000) * 100 * 100) / 100).toFixed(2)}%`,
          `￥${d.trackingPointCpaTotal}`,
          `￥${d.trackingPointCpaClickThrough}`,
          ...generateSetPointColumns(d.trackingPointCpaClickThroughSetPoints, TRACKING_POINT.CPA_CLICK_THROUGH, mergedSetPoints),
          `￥${d.trackingPointCpaAssist}`,
          d.lastCvTotal,
          `${(Math.floor((Math.round(d.lastCvrTotal * 1000000) / 1000000) * 100 * 100) / 100).toFixed(2)}%`,
          `￥${d.lastCpaTotal}`,
        ],
      };
      dataList.push(list);
    }
  );
  return dataList;
}

export const generateSetPointColumns = (value: PerfomanceSetPoints[], columnName: string, mergedSetPoints: Option[]): string[] => {
  let setPointColumns:string[] = [];
  for (let i = 0; i < mergedSetPoints.length; i++) {
    const targetItem = value.find((item) => item.id === mergedSetPoints[i].value);
    if (targetItem) {
      setPointColumns.push(getSetPointColumnLabel(columnName, targetItem.value));
    } else {
      setPointColumns.push(getSetPointColumnLabel(columnName, 0));
    }
  }
  return setPointColumns;
};

export const generateColumns = (columns: MUIDataTableColumnDef[], storageKey: string, setPoints: Option[], deletedSetPoints: Option[]) => {
  const new_columns = [...columns];
  let setpoint_columns_length = 0;
  columns.forEach((column, index) => {
    if (typeof column !== 'string' && SUMMARY_SETPOINT_COLUMNS.includes(column.name)) {
      const local_columns_setPoint:MUIDataTableColumn[] = [];
      for (const setpoint of setPoints) {
        var local_column_setpoint: MUIDataTableColumn = {
          name: `${column.name}SetPoints`,
          label: `${valueToLabel(column.name, options_setpoint_columns)}(${setpoint.label})`,
          options: {
            filter: false,
            sort: true,
            apolloColumnId: getApolloDynamicColumnId(column.name, setpoint.value),
            setCellProps: () => ({style: {minWidth: "8rem"}}),
            customBodyRender: (value: PerfomanceSetPoints[]) => {
              if (value) {
                const targetItem = value.find((item) => item.id === setpoint.value);
                if (targetItem) {
                  return getSetPointColumnLabel(column.name, targetItem.value);
                }
              }
              return getSetPointColumnLabel(column.name, 0);
            }
          } as any
        }
        local_columns_setPoint.push(local_column_setpoint);
      }
      for (const setpoint of deletedSetPoints) {
        var local_column_setpoint: MUIDataTableColumn = {
          name: `${column.name}SetPoints`,
          label: `${valueToLabel(column.name, options_setpoint_columns)}(${setpoint.label})`,
          options: {
            filter: false,
            sort: true,
            apolloColumnId: getApolloDynamicColumnId(column.name, setpoint.value, true),
            display: localStorage.getItem(storageKey) ? undefined : false,
            setCellProps: () => ({style: {minWidth: "8rem"}}),
            customBodyRender: (value: PerfomanceSetPoints[]) => {
              if (value) {
                const targetItem = value.find((item) => item.id === setpoint.value);
                if (targetItem) {
                  return getSetPointColumnLabel(column.name, targetItem.value);
                }
              }
              return getSetPointColumnLabel(column.name, 0);
            }
          } as any
        }
        local_columns_setPoint.push(local_column_setpoint);
      }
      new_columns.splice(index+setpoint_columns_length+1, 0, ...local_columns_setPoint);
      setpoint_columns_length += local_columns_setPoint.length;
    }
  });

  return new_columns;
}

const getSetPointColumnLabel = (columnName: string, value: number) => {
  let val = "";
  switch (columnName) {
    case TRACKING_POINT.CV_CLICK_THROUGH:
    case TRACKING_POINT.CV_ASSIST:
      val = value.toLocaleString();
      break;
    case TRACKING_POINT.CVR_CLICK_THROUGH:
      val = (Math.floor(value * 100 * 100) / 100).toFixed(2) + "%";
      break;
    case TRACKING_POINT.CPA_CLICK_THROUGH:
      val = "¥" + value.toLocaleString();
      break;
    default:
      break;
  }
  return val;
}

export const generateCsvHeader = (columns: ColumnData[], setPoints: Option[], deletedSetPoints: Option[]) => {
  let new_columns: ColumnData[] = JSON.parse(JSON.stringify([...columns]));

  let setpoint_columns_length = 0;
  let mergedSetPoints = [...setPoints, ...deletedSetPoints];

  columns.forEach((column, index) => {
    options_setpoint_columns.map(option => {
      if (option.label === column.label.replace("(合計)", "")) {
        const local_columns_setPoint:ColumnData[] = [];
        for (const setpoint of mergedSetPoints) {
          var local_column_setpoint: ColumnData = {
            download: true,
            label: `${option.label}(${setpoint.label})`,
          }
          local_columns_setPoint.push(local_column_setpoint);
        }
        new_columns.splice(index+setpoint_columns_length+1, 0, ...local_columns_setPoint);
        setpoint_columns_length += local_columns_setPoint.length;
      }
    });
  });

  return new_columns;
}

export default ISummaryPage;
